import React from "react";
import classnames from "classnames";

const Container = ({ className, children, ...otherProps }) => {
    return (
        <div className={classnames(className, "max-w-7xl mx-auto px-6 lg:px-8")} {...otherProps}>
            {children}
        </div>
    );
};

export default Container;
